/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FaceSmileRegularV6 = (props) => (
  <Icon {...props} name="Face Smile Regular V6">
    <path d="M8 11a3.295 3.295 0 0 0 2.45-1.059.75.75 0 0 1 1.059-.044.75.75 0 0 1 .041 1.059C10.866 11.703 9.678 12.5 8 12.5s-2.866-.797-3.55-1.544c-.281-.303-.291-.778.041-1.059a.75.75 0 0 1 1.059.044A3.291 3.291 0 0 0 8 11zM6.513 6.5a1 1 0 1 1-2.002.002A1 1 0 0 1 6.513 6.5zm2.999 0a1 1 0 1 1 1.998-.002 1 1 0 0 1-1.998.002zM16 8c0 4.419-3.581 8-8 8s-8-3.581-8-8c0-4.419 3.581-8 8-8s8 3.581 8 8zM8 1.5C4.409 1.5 1.5 4.409 1.5 8s2.909 6.5 6.5 6.5 6.5-2.909 6.5-6.5S11.591 1.5 8 1.5z" />
  </Icon>
);

export default FaceSmileRegularV6;
